var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map",on:{"click":_vm.goToMap}},[_c('LazyImg',{attrs:{"url":_vm.src,"alt":"Koba jiujitsu location"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }